import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash.get';

import Global from '../../../store/global-selectors';
import { messages } from './messages';
import { emptyArray } from 'ui-components/default-props/empty';

const ConfirmationColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  const carriers = useSelector(Global.selectReferenceDatagetSellerCarriers);
  if (!ret) {
    return '';
  }

  const { returnConfiguration } = ret || {};
  const { options, carrierId } = returnConfiguration || {};
  const { confirmationEnumId } = options || {};

  if (!carrierId || confirmationEnumId == null) {
    return '';
  }

  const selectedCarrier = carriers.find((carrier) => carrier?.carrierId === carrierId);
  if (!selectedCarrier) {
    return '';
  }

  const confirmations = get(selectedCarrier, 'confirmations') || emptyArray;

  const confirmationObject = confirmations.find(
    (confirmation) => parseInt(confirmation.confirmationId, 10) === parseInt(confirmationEnumId, 10),
  );

  return confirmationObject?.name || '';
};

export const Confirmation = {
  getMessageDescriptor: () => messages.confirmation,
  id: 'confirmation',

  render: ({ fulfillmentId }) => {
    return <ConfirmationColumn fulfillmentId={fulfillmentId} />;
  },
};
